import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { chargeChairRentalPayment } from '../actions';
import ChairRentalChargeableAmount from '../components/ChairRentalChargeableAmount';
import withToggle from '../../../../common/hoc/withToggle';
import confirmModal from '../../../../common/confirmModal';
import withNotifications from '../../../../common/withNotifications';

const mapDispatchToProps = {
  chargeChairRentalPayment,
};

const MARK_PAID_CHARGE_MESSAGE = ['Would you like to charge the overdue amount to the card on file?',
  'Alternatively, you can mark the overdue amount as paid for your records.'].join('');

export default compose(
  connect(null, mapDispatchToProps),
  withNotifications,
  withToggle(),
  withHandlers({
    markAsPaidOrCharge: props => () => confirmModal({
      title: '',
      message: MARK_PAID_CHARGE_MESSAGE,
      type: 'default',
      confirmButtonText: 'Charge',
      negativeButtonText: 'Mark as paid',
    },
    () => props.chargeChairRentalPayment(props.barberId, props.payment.id)
      .then(() => props.addNotification({
        level: 'success',
        message: 'Payment sucessfully charged.',
        title: 'Success',
      }))
      .then(() => props.off())
      .catch(() => props.off()),

    () => props.chargeChairRentalPayment(props.barberId, props.payment.id, { markAsPaid: true })
      .then(() => props.addNotification({
        level: 'success',
        message: 'Payment sucessfully marked as paid.',
        title: 'Success',
      }))
      .then(() => props.off())
      .catch(() => props.off()),
      () => props.off(),
    ),
  })
)(ChairRentalChargeableAmount);
